import React from "react";
import { Link, Typography } from "@mui/material";
import { API_BASE } from "../../utils/apiBase";

export default function LeaveAttachmentLink({ row }) {
  const url = row?.file_url || (row?.id && (row?.file_path || row?.attachment) ? `${API_BASE}/api/leave-requests/${encodeURIComponent(row.id)}/attachment` : null);
  const label = row?.attachment_name || row?.file_name || "View Attachment";

  if (!url) {
    return (
      <Typography variant="caption" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Link href={url} target="_blank" rel="noreferrer" underline="hover">
      {label}
    </Link>
  );
}
